import { Disclaimer } from 'src/app/shared/models/disclaimer';

export class PersonDisclaimer {
  public acceptedOn: Date;
  public disclaimer: Disclaimer;

  constructor(acceptedOn: Date, disclaimer: Disclaimer) {
    this.acceptedOn = acceptedOn;
    this.disclaimer = disclaimer ? Disclaimer.parse(disclaimer) : null;
  }

  public static parse(data: any): PersonDisclaimer {
    return new PersonDisclaimer(data.acceptedOn, data.disclaimer);
  }
}
